import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/_motion/UseLenis.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
